import {Component, OnInit} from '@angular/core';
import {Trabalho} from "../trabalho/trabalho";
import {AppComponent} from "../app.component";
import {TrabalhoService} from "../trabalho/trabalho.service";
import {AcessoService} from "../acesso/acesso.service";
import {CertificadoService} from "../certificado/certificado.service";


@Component({
	selector: 'app-certificado',
	templateUrl: './certificado.component.html',
	styleUrls: ['./certificado.component.css'],
	providers: [
		AcessoService,
		CertificadoService
	]
})
export class CertificadoComponent extends AppComponent implements OnInit {
	trabalhos: Trabalho[];

	ngOnInit(): void {
        if (this.islogged() && this.isAdmin()) 
			this.certificadoService.getTrabalhos().then(trabalhos => this.trabalhos = trabalhos); 
		else 
            this.router.navigateByUrl('acesso');
    }
	
	exportar(trabalho: any): void {
		this.certificadoService.exportar(trabalho.trabalho_id).then(resp => trabalho.data_certificado = new Date());
	}
	
	eventoFinalizado(trabalho: any): boolean {
		let tamanho: number = trabalho.etapas.length - 1;
		if (tamanho >= 0) {
			let ontem = new Date();
			ontem.setDate(new Date().getDate() - 1);
			return new Date(trabalho.etapas[tamanho].data_fim) < ontem;
		}
		return true;
	}

}



// WEBPACK FOOTER //
// ./src/app/certificado/certificado.component.ts